import { SessionResponse } from './types';
import { BASE_URL, REACT_APP_OLE_API_KEY } from '../../config';
import { uuidv4 } from 'services/common';
import * as Sentry from '@sentry/react';

const getSession = async (token: string, region: string): Promise<SessionResponse> => {
  //console.log('[session] Fetching session for token:', token, 'and region:', region);
  try {
    const response = await fetch(`${BASE_URL}/api-payments/v1/session?token=${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': REACT_APP_OLE_API_KEY,
        'X-User': 'web',
        'X-Request-ID': uuidv4(),
        'X-Payment-Gateway': 'FLY'
      }
    });
    //console.log('[session] Response status:', response.status);
    if (!response.ok) {
      throw new Error('Error fetching session');
    }
    const data = await response.json();
    Sentry.logger.info('sessionService[getSession]', { session: token, response: data });
    return data;
  } catch (error) {
    //console.error('[session]', error);
    Sentry.logger.error('sessionService[getSession] error', { session: token, error });
    throw error;
  }
};

export { getSession };